"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyInvertableList = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
var values_1 = tslib_1.__importDefault(require("lodash/values"));
var take_1 = tslib_1.__importDefault(require("lodash/take"));
var has_1 = tslib_1.__importDefault(require("lodash/has"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var Form_1 = require("../Form");
var LegacyMultiSelectList_1 = tslib_1.__importDefault(require("./LegacyMultiSelectList"));
var LegacyMultiSelectListItem_1 = tslib_1.__importDefault(require("./LegacyMultiSelectListItem"));
var Messages_1 = require("../Messages");
var guid_1 = require("./guid");
var NoItemsFound = function () {
    return (react_1.default.createElement("div", { className: "gd-list-noResults" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.noItemsFound" })));
};
var LoadingMessage = function () {
    return react_1.default.createElement("div", null, "...");
};
var LimitHitWarning = function (_a) {
    var limit = _a.limit, bounce = _a.bounce;
    var classes = classnames_1.default("gd-list-limitExceeded", {
        "animation-fadeIn": bounce,
    });
    return (react_1.default.createElement(Messages_1.Message, { type: "warning", className: classes },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.limitExceeded", values: { limit: limit } })));
};
/**
 * @internal
 * @deprecated This component is deprecated use InvertableList instead
 */
var LegacyInvertableList = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyInvertableList, _super);
    function LegacyInvertableList(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelect = function (item) {
            var newSelection = _this.toggleItemInSelection(item);
            if (newSelection.length <= _this.props.maxSelectionSize) {
                _this.notifyUpstreamOfSelectionChange(newSelection);
            }
            if (newSelection.length >= _this.props.maxSelectionSize) {
                // Flash the limit exceeded info
                _this.setState({
                    notifyLimitHit: true,
                });
                // remove the class that causes flashing animation
                setTimeout(function () {
                    _this.setState({
                        notifyLimitHit: false,
                    });
                }, 1000);
            }
        };
        _this.onSelectAll = function () {
            if (_this.props.searchString) {
                if (_this.props.isInverted) {
                    _this.shrinkSelection();
                }
                else {
                    _this.growSelection();
                }
            }
            else {
                _this.props.onSelect([], true);
            }
        };
        _this.onSelectNone = function () {
            if (_this.props.searchString) {
                if (_this.props.isInverted) {
                    _this.growSelection();
                }
                else {
                    _this.shrinkSelection();
                }
            }
            else {
                _this.props.onSelect([], false);
            }
        };
        _this.onSelectOnly = function (item) {
            _this.props.onSelect([item], false);
        };
        // private onSearchChange(searchString: string) {
        //     this.props.onSearch(searchString);
        // }
        _this.onRangeChange = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.props).onRangeChange.apply(_a, tslib_1.__spread([_this.props.searchString], args));
        };
        _this.state = {
            notifyLimitHit: false,
        };
        return _this;
    }
    /**
     * Remove selected visible items from selection.
     */
    LegacyInvertableList.prototype.shrinkSelection = function () {
        var _a = this.props, items = _a.items, selection = _a.selection;
        var visibleSelection = this.intersectItems(items, selection);
        var newSelection = this.subtractItems(selection, visibleSelection);
        this.notifyUpstreamOfSelectionChange(newSelection);
    };
    LegacyInvertableList.prototype.intersectItems = function (items, otherItems) {
        var _this = this;
        var otherItemsMap = this.indexByKey(otherItems);
        return items.filter(function (item) {
            var itemKey = _this.props.getItemKey(item);
            return !!otherItemsMap[itemKey];
        });
    };
    LegacyInvertableList.prototype.subtractItems = function (items, otherItems) {
        var _this = this;
        var otherItemsMap = this.indexByKey(otherItems);
        return items.filter(function (item) {
            var itemKey = _this.props.getItemKey(item);
            return !otherItemsMap[itemKey];
        });
    };
    LegacyInvertableList.prototype.indexByKey = function (items) {
        if (items === void 0) { items = []; }
        return keyBy_1.default(items, this.props.getItemKey);
    };
    LegacyInvertableList.prototype.toggleItemInSelection = function (item) {
        var selectionMap = this.indexByKey(this.props.selection);
        var itemKey = this.props.getItemKey(item);
        if (selectionMap[itemKey]) {
            delete selectionMap[itemKey];
        }
        else {
            selectionMap[itemKey] = item;
        }
        return values_1.default(selectionMap);
    };
    /**
     * Add unselected visible items to the selection until selection size limit is reached.
     */
    LegacyInvertableList.prototype.growSelection = function () {
        var _a = this.props, maxSelectionSize = _a.maxSelectionSize, items = _a.items, selection = _a.selection;
        var selectionSizeLeft = maxSelectionSize - selection.length;
        var selectableItems = this.subtractItems(items, selection);
        var itemsToSelect = take_1.default(selectableItems, selectionSizeLeft);
        var newSelection = tslib_1.__spread(selection, itemsToSelect);
        this.notifyUpstreamOfSelectionChange(newSelection);
    };
    /**
     * If change in selection happens to select all or unselect all items it is converted
     * to the respective empty selection.
     */
    LegacyInvertableList.prototype.notifyUpstreamOfSelectionChange = function (newSelection) {
        var _a = this.props, itemsCount = _a.itemsCount, searchString = _a.searchString;
        var isInverted = this.props.isInverted;
        var selection;
        var lastItemSelected = !isInverted && !searchString && newSelection.length === itemsCount;
        if (lastItemSelected) {
            selection = [];
            isInverted = !isInverted;
        }
        else {
            selection = newSelection;
        }
        this.props.onSelect(selection, isInverted);
    };
    LegacyInvertableList.prototype.isItemChecked = function (selectionMap, item) {
        var key = this.props.getItemKey(item);
        var itemInSelection = has_1.default(selectionMap, key);
        // in inverted mode selection lists unchecked items
        // in normal mode selection contains checked items
        return this.props.isInverted ? !itemInSelection : itemInSelection;
    };
    LegacyInvertableList.prototype.renderLimitHitWarning = function () {
        var _a = this.props, maxSelectionSize = _a.maxSelectionSize, selection = _a.selection;
        var limitHit = selection.length >= maxSelectionSize;
        if (limitHit) {
            return (react_1.default.createElement(this.props.limitHitWarningClass, { limit: maxSelectionSize, bounce: this.state.notifyLimitHit }));
        }
        return null;
    };
    LegacyInvertableList.prototype.renderSearchField = function () {
        return this.props.showSearchField ? (react_1.default.createElement(Form_1.Input, { autofocus: true, className: "gd-list-searchfield gd-flex-item-mobile", clearOnEsc: true, isSearch: true, isSmall: this.props.smallSearch, onChange: this.props.onSearch, placeholder: this.props.searchPlaceholder, value: this.props.searchString })) : null;
    };
    LegacyInvertableList.prototype.renderList = function () {
        return this.props.isLoading ? (this.renderLoading()) : (react_1.default.createElement("div", { className: "gd-flex-item-stretch-mobile gd-flex-row-container-mobile" },
            this.renderListOrNoItems(),
            this.renderLimitHitWarning()));
    };
    LegacyInvertableList.prototype.renderListOrNoItems = function () {
        var _a = this.props, items = _a.items, searchString = _a.searchString, filteredItemsCount = _a.filteredItemsCount, height = _a.height, selection = _a.selection;
        if (searchString && filteredItemsCount === 0) {
            return react_1.default.createElement(this.props.noItemsFoundClass, { height: height });
        }
        var selectionMap = this.indexByKey(selection);
        var isChecked = this.isItemChecked.bind(this, selectionMap);
        var listProps = tslib_1.__assign(tslib_1.__assign({}, this.props), { itemsCount: filteredItemsCount });
        return (react_1.default.createElement(LegacyMultiSelectList_1.default, tslib_1.__assign({}, listProps, { onSelect: this.onSelect, onSelectAll: this.onSelectAll, onSelectNone: this.onSelectNone, onSelectOnly: this.onSelectOnly, items: items, isSelected: isChecked, isSearching: !!searchString.length, listItemClass: this.props.listItemClass, onRangeChange: this.onRangeChange, tagName: this.props.tagName })));
    };
    LegacyInvertableList.prototype.renderLoading = function () {
        return react_1.default.createElement(this.props.isLoadingClass, { height: this.props.height });
    };
    LegacyInvertableList.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, className = _a.className;
        var classNames = classnames_1.default(className, {
            "gd-flex-item-stretch-mobile": isMobile,
            "gd-flex-row-container-mobile": isMobile,
        });
        return (react_1.default.createElement("div", { className: classNames },
            this.renderSearchField(),
            this.renderList()));
    };
    LegacyInvertableList.defaultProps = {
        actionsAsCheckboxes: false,
        className: undefined,
        getItemKey: guid_1.guidFor,
        isInverted: true,
        isLoading: false,
        isLoadingClass: LoadingMessage,
        isMobile: false,
        limitHitWarningClass: react_intl_1.injectIntl(LimitHitWarning),
        listItemClass: LegacyMultiSelectListItem_1.default,
        noItemsFound: false,
        noItemsFoundClass: react_intl_1.injectIntl(NoItemsFound),
        onRangeChange: noop_1.default,
        onSelect: noop_1.default,
        searchPlaceholder: "",
        searchString: "",
        selection: [],
        showSearchField: true,
        smallSearch: false,
        tagName: "",
        selectAllCheckbox: false,
    };
    return LegacyInvertableList;
}(react_1.Component));
exports.LegacyInvertableList = LegacyInvertableList;
/**
 * @internal
 * @deprecated This component is deprecated use InvertableList instead
 */
var LegacyInvertableListWithIntl = react_intl_1.injectIntl(LegacyInvertableList);
exports.default = LegacyInvertableListWithIntl;
//# sourceMappingURL=LegacyInvertableList.js.map